import { hot } from 'react-hot-loader';
import Seo from '../components/Seo';
import Footer from '../components/Footer';
import ScreenWallet2 from '../screens/ScreenWallet2';



function WalletPage2(props) {
  return (
    <Seo title={`Wallet`} meta={[]}>
      <ScreenWallet2 />
      <Footer />
    </Seo>
  );
};

export default hot(module)(WalletPage2);
